export const EMPTY_USER_NAME_LOCAL = 100;
export const EMPTY_USER_LAST_NAME_LOCAL = 110;
export const EMPTY_USER_EMAIL_LOCAL = 120;
export const INVALID_FORMAT_USER_EMAIL_LOCAL = 121;
export const EMPTY_USER_PHONE_LOCAL = 130;
export const INVALID_FORMAT_USER_PHONE_LOCAL = 131;
export const INVALID_FORMAT_USER_ADDITIONAL_PHONE_LOCAL = 140;
export const EMPTY_USERID = 170;
export const INVALID_EXTERNAL_ID = 180;
export const EMPTY_DATE_OF_BIRTH_LOCAL = 190;
export const INVALID_DATE_OF_BIRTH_LOCAL = 200;

export const localErrorMessagesMap = {
  [INVALID_FORMAT_USER_PHONE_LOCAL]: {
    id: 'MyAccount.Details.Edit.InvalidPhoneNoFormatError',
    defaultMessage: '** Invalid phone number format',
  },
  [INVALID_FORMAT_USER_EMAIL_LOCAL]: {
    id: 'MyAccount.Details.Edit.InvalidEmailFormatError',
    defaultMessage: '** Invalid Email format',
  },
  [INVALID_EXTERNAL_ID]: {
    id: 'Users.UserDetails.InvalidUserIDFormat',
    defaultMessage: '** Invalid User ID format',
  },
  [EMPTY_USERID]: {
    id: 'Patient.Appointment.Create.MissingMandatoryFieldError.TextField',
    defaultMessage: '** :attribute is required',
  },
  [INVALID_FORMAT_USER_ADDITIONAL_PHONE_LOCAL]: {
    id: 'MyAccount.Details.Edit.InvalidPhoneNoFormatError',
    defaultMessage: '** Invalid phone number format',
  },
  [EMPTY_USER_NAME_LOCAL]: {
    id: 'MyAccount.Details.Edit.GivenNameIsReuiredError',
    defaultMessage: '** Given name is a required field',
  },
  [EMPTY_USER_LAST_NAME_LOCAL]: {
    id: 'MyAccount.Details.Edit.FamilyNameIsReuiredError',
    defaultMessage: '** Family name is a required field',
  },
  [EMPTY_USER_PHONE_LOCAL]: {
    id: 'MyAccount.Details.Edit.MobilePhoneReuiredError',
    defaultMessage: '** Mobile phone number is a required field',
  },
  [EMPTY_USER_EMAIL_LOCAL]: {
    id: 'MyAccount.Details.Edit.EmailRequiredError',
    defaultMessage: '** Email is a required field',
  },
  [EMPTY_DATE_OF_BIRTH_LOCAL]: {
    id: 'MyAccount.Details.Edit.DateOfBirthIsReuiredError',
    defaultMessage: '** Date of Birth is a required field',
  },
  [INVALID_DATE_OF_BIRTH_LOCAL]: {
    id: 'MyAccount.Details.Edit.DateOfBirthInvalidFormatError',
    defaultMessage: '** Invalid Date of Birth format',
  },
};
